<template>
  <nav class=" " style="background-color: #C38437">
   
    <div class="h-[calc(100dvh)] mx-auto p-2 md:max-w-7xl lg:max-w-7xl mx-auto px-2 sm:px-2 lg:px-2">
      <div class="flex items-center justify-between h-16">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <img @click = "home()"
              class="h-28 w-full rounded-full pt-2"
              src="../assets/gracefinal.png"
              alt="Workflow logo"
            />
          </div>
          <div>
           <!--<h2 
          class=" flex text-2xl text-white sm:text-2xl md:text-4xl pl-2"
          >
           Grace <b class="text-blue-900"></b><b style="color: #84714E">_</b><b style="color: #B5835B" class=""></b> Vine 
        </h2>-->
            
          </div>
          <div class="hidden md:block">
            <div class="ml-10 flex items-baseline">
              <router-link
                v-for="route in routeDisplayList(routeList)"
                :key="`lg-${route.name}`"
                :to="{ name: route.name }"
                :class="{
                  'ml-4 px-3 py-2 rounded-md text-sm font-medium text-white bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-700': isCurrentRoute(
                    route.name
                  ),
                  'ml-4 px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700': !isCurrentRoute(
                    route.name
                  ),
                }"
                >{{ route.text }}</router-link
              >
            </div>
          </div>
            <div  class="ml-2 mt-2">
            <button  @click = "Calendar();"
              
              
            >
              <img
                class="h-8 w-8 rounded-full"
                border="0"
                alt="W3Schools"
                src="../assets/calendar.png"
                width="100"
                height="100"
              />
              
            </button>
        
       
          </div> 
          <div v-if="!isLoggedIn" class="ml-2">
            <a
              href="https://www.facebook.com/p/Grace-Baptist-Church-Port-Elizabeth-100082229370925/"
              target="_blank"
              
            >
              <img
                class="h-8 w-8 rounded-full"
                border="0"
                alt="W3Schools"
                src="../assets/facebook2.png"
                width="100"
                height="100"
              />
              
            </a>
       
          </div> 
         <div v-if="!isLoggedIn" class="ml-2">
                     <a
              href="https://www.youtube.com/@gracebaptistchurchporteliz4586"
              target="_blank"
              
            >
              <img
                class="h-8 w-8 rounded-full"
                border="0"
                alt="W3Schools"
                src="../assets/play.png"
                width="100"
                height="100"
              />
              
            </a>
          </div> 
        </div>
        <div class="hidden md:block">
          <div class="ml-4 flex items-center md:ml-6">
          <!--<div v-if="isLoggedIn && currentUserData.userType === 'admin' || currentUserData.userType === 'user' || currentUserData.userType === 'Registering' || currentUserData.onboardingComplete === false " class="text-white">
            Welcome : {{currentUserData.name}} 
          </div>-->
            <!-- Profile dropdown -->
            <div class="ml-3 relative" v-if="isLoggedIn">
              <div @click="toggleSubmenu">
                <button
                  v-if="currentUserData.userType !== 'employeruser'"
                  class="max-w-xs flex items-center text-sm rounded-full text-white focus:outline-none focus:shadow-solid"
                  id="user-menu"
                  aria-label="User menu"
                  aria-haspopup="true"
                >
               <!-- <img
              v-if="currentUserData.userType === 'admin'"
              class="h-8 w-8 rounded-full"
              src="../assets/employeruserprofile.png"
              alt
            />
            <img
              v-if="currentUserData.userType === 'Registering'"
              class="h-8 w-8 rounded-full"
              src="../assets/employeruserprofile.png"
              alt
            />-->
                </button>
         
              </div>
              <!--
                Profile dropdown panel, show/hide based on dropdown state.

                Entering: "transition ease-out duration-100"
                  From: "transform opacity-0 scale-95"
                  To: "transform opacity-100 scale-100"
                Leaving: "transition ease-in duration-75"
                  From: "transform opacity-100 scale-100"
                  To: "transform opacity-0 scale-95"
              -->
              <div
                class="origin-top-right right-0 mt-2 w-48 rounded-md shadow-lg z-10"
                v-if="submenuOpen"
              >
                <div
                  class="py-1 rounded-md bg-white shadow-xs"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="user-menu"
                >   
                  <button
                    v-on:click="
                      signOut();
                      toggleSubmenu();
                    "
                    class="block px-4 py-2 text-sm text-blue-600 hover:text-red-600"
                    role="menuitem"
                  >
                    Sign out
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isLoggedIn" class="-mr-2 flex">
          <!-- Mobile menu button -->
          <button
            v-on:click="toggleMobilemenu();"
            class=" inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
          >
            <!-- Menu open: "hidden", Menu closed: "block" -->
            <svg
              class="block h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <!-- Menu open: "block", Menu closed: "hidden" -->
            <svg
              class="hidden h-6 w-6"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!--
      Mobile menu, toggle classes based on menu state.

      Open: "block", closed: "hidden"
    -->
    <div v-if="mobileOpen" class=" mx-auto px-4 sm:px-6 lg:px-8 ">
      <div v-if="mobileOpen" class="px-2 pt-2 pb-3 sm:px-3 ">
     

      </div>
      <div v-if="isLoggedIn" class="pt-4 pb-3 border-t border-gray-700">

        <div class="mt-3 px-2 text-center">
       
          
          <a
            
            v-on:click="
              dashboard();
              toggleMobilemenu();
            "
            class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
            >Home</a
          >
     
          <a
            v-on:click="
              signOut();
              toggleMobilemenu();
            "
            class="mt-1 block px-3 py-2 rounded-md text-base font-medium text-white hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
            >Sign Out</a
          >
          
  
        </div>
        
      </div>
      
    </div>
   <AdminCalendar v-if="tab === 'viewCalendar'" />
  </nav>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
//import Sidebar from "../components/Sidebar";
import AdminCalendar from "./AdminCalendar";
//import Slider from '../components/Slider'

export default {
  name: "Navbar",
  components: { AdminCalendar},
  data() {
    return {
      defaultProfilePicture:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
      user: "",
      pages1: "",
      //pages2: {},
      employer: "",
      tab: "",
      submenuOpen: false,
      mobileOpen: false,
      mobileOpen10: false,
      routeList: [
      
        
       {
        name: "dashboard",
          text: "Home",
          display: () => this.isLoggedIn,
        },
        
     // {
       //   name: "contact",
        //  text: "Contact Us",
       //   display: () => !this.isLoggedIn,
      //  },
        //{
        //  name: "userlogin",
        //  text: "Login/Register",
        //  display: () => !this.isLoggedIn,
       // },
        {
          name: "admin",
          text: "Admin",
          display: () =>
            this.userData &&
            Array.isArray(this.userData.roles) &&
            this.userData.roles.includes("admin"),
        },
        //{
          //name: "auth",
          //text: "Login/Register",
          //display: () => !this.isLoggedIn,
        //},
      ],
    };
  },
  created() {
    this.userData = this.currentUserData;
    //this.getPages1();
    //this.getUserData();
   
  },
  mounted() {
    //this.getPages2();
   // this.getUserData();
  },
  computed: {
    ...mapGetters(["isLoggedIn", "currentUserData"]),
  },
  methods: {
    ...mapActions(["setCurrentUser"]),
    isCurrentRoute(routeName) {
      return this.$route.name === routeName;
    },
    setTab(tab) {
      this.tab = tab;
    },
    toggleSubmenu() {
      this.submenuOpen = !this.submenuOpen;
    },
    toggleMobilemenu() {
      this.mobileOpen = !this.mobileOpen;
    },
    toggleMobilemenu10() {
      this.mobileOpen10 = !this.mobileOpen10;
    },
    employerProfile() {
      this.$router.push({
        name: "employerprofile",
      });
    },
    employeeProfile() {
      this.$router.push({
        name: "dashboard",
      });
    },
    dashboard() {
      this.$router.push({
        name: "dashboard",
      });
    },
    searchIncidents() {
      this.$router.push({
        name: "incidents",
      });
    },
    approvals() {
      this.$router.push({
        name: "approvals",
      });
    },
    home() {
      this.$router.push({
        name: "Home",
      });
    },
       Calendar() {
      this.$router.push({
        name: "Calendar",
      });
    },
       RAS() {
      this.$router.push({
        name: "ras",
      });
    },
    examinerProfile() {
      this.$router.push({
        name: "examinerprofile",
      });
    },
    addUser() {
      this.$router.push({
        name: "employeradduser",
      });
    },
    signOut() {
      this.$firebase
        .auth()
        .signOut()
        .then(() => {
          this.setCurrentUser(null);
          this.$router.push({
            name: "Home",
          });
        });
    },
     getPages1() {
      //const employer = [];
      const employerData = this.$db
        .collection("websitestatus")
        .where("status", "==", "active");

      employerData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.pages1 = data;
        });
      });
    },
    getUserData() {
      if (
        this.currentUserData.idNumber &&
        this.currentUserData.email &&
        this.currentUserData.contactNumber
      ) {
        const userData = this.$db
          .collection("users")
          .where("idNumber", "==", this.currentUserData.idNumber)
          .where("email", "==", this.currentUserData.email)
          .where("contactNumber", "==", this.currentUserData.contactNumber);

        userData.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              ...doc.data(),
            };
            this.user = data;
          });
        });
      }
    },
    getEmployerData() {
      if (this.currentUserData.employer) {
        const employerData = this.$db
          .collection("employers")
          .where("user", "==", this.currentUserData.employer);

        employerData.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              ...doc.data(),
            };
            this.company = data;
          });
        });
      }
    },
    getPages2() {
      //const employer = [];
      const employerData = this.$db
        .collection("websitepages")
        .where("status", "===", "active");

      employerData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.pages2 = data;
        });
      });
    },
    getEmployer() {
      //const employer = [];
      const employerData = this.$db
        .collection("employers")
        .where("user", "==", this.$auth.currentUser.uid);

      employerData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.employer = data;
        });
      });
    },
    routeDisplayList(routeList) {
      return routeList.filter((route) => !route.display || route.display());
    },
  },
};
</script>
